<template>
<div class="loginClass" :style="loginClass">
  <img src="../../assets/imgs/bg2.jpg" class="background" width="100%" height="100%" alt="" />
  <span style="float: left;margin-left: 20px;">
    <img src="../../assets/imgs/logos.png" width="150px" height="60px"/>
  </span>
  <el-card class="login-card">
      <div class="blue"></div>
      <p>{{$t('lang.lab_conpanyName')}}</p>
      <!-- <div class="line1"></div> -->
      <div class="line2"></div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="name" label-width='32px'>
          <el-input v-model="ruleForm.name" :placeholder="this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_account')" class="inputext1"></el-input>
        </el-form-item>
        <el-form-item prop="password" label-width='32px'>
          <el-input v-model="ruleForm.password" type="password" :placeholder="this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_password')" class="inputext2"></el-input>
        </el-form-item>
      <el-button type="primary" @click="login('ruleForm')" class="btn1">{{$t('lang.lab_login')}}</el-button>
      </el-form>
  </el-card>
</div>
</template>

<script>
let Base64 = require('js-base64').Base64
export default {
  // import引入的组件需要注入到对象中才能使用
  name: 'login',
  components: {},
  data() {
    // 这里存放数据
    return {
      name: '',
      password: '',
      flag: false,
      loginClass: {
        backgroundImage: 'url(' + require('../../assets/imgs/bg2.jpg') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        overflow: 'hidden',
        width: '100%',
        height: '100%',
      },
      ruleForm: {
        name: '',
        password: '',
      },
      rules: {
        name: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + '账号', trigger: 'blur' }],
        password: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + '密码', trigger: 'blur' }],
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化d
  watch: {},
  // 方法集合
  methods: {
    // 监听回车事件
    listenEnter() {
      var _this = this
      document.onkeydown = function(e) {
        let key = window.event.keyCode
        if (key == 13) {
          _this.login('ruleForm')
        }
      }
    },
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          let params = {
            accountNumber: this.ruleForm.name,
            password: this.ruleForm.password
          }
          this.$postJson(`/user/backendLogin`, params).then(
            res => {
              if (res && res.code === 200) {
                // 登陆成功 设置用户信息
                console.log('登陆成功', res.data)
                window.localStorage.setItem('accountNumber', res.data.accountNumber)
                if (res.data.isAdmin) {
                  this.flag = true
                } else {
                  this.flag = false
                }
                // 是否禁用
                if (res.data.accountStatus === 0) {
                  console.log('正常')
                  this.$message.success(this.$i18n.t('lang.lab_successLogin'))
                  this.$router.push({ path: '/manage' })
                } else {
                  console.log('禁用')
                  this.$message.error(this.$i18n.t('lang.warning_ban'))
                }
                // 假设这里是后台返回的 token
                 window.localStorage.setItem('token', 'i_am_token')
              } else {
                this.$message.error(res.message)
              }
              loading.close()
              console.log(res)
              let res1 = {}
              if (this.flag) {
                res1 =
                  { 'id': 100006, 
                    'isDispatch': 1, 
                    'fsToken': 'XxlbSgABhqYF9jUvIUu7N0EfFz2lC3NCBl5upg..', 
                    'style': '#00b1c3,#006d9a',
                    'nickName': '超级管理员',
                    'errMsg': '执行成功',
                    'errCode': 0,
                    'gardenList': [{ 'id': 0, 'name': '全部小区' }, { 'id': 9, 'name': '格林生活坊一期' }, { 'id': 11, 'name': '格林生活坊三期' }, { 'id': 12, 'name': '格林观堂一期' }, { 'id': 13, 'name': '格林观堂二期' }, { 'id': 14, 'name': '格林喜鹊花园' }, { 'id': 15, 'name': '格林SOHO' }, { 'id': 16, 'name': '格林常青藤' }, { 'id': 17, 'name': '格林繁荣里' }, { 'id': 18, 'name': '格林豪森' }, { 'id': 19, 'name': '格林康泉府' }, { 'id': 20, 'name': '格林梦夏' }, { 'id': 21, 'name': '格林mini' }, { 'id': 22, 'name': '格林馨港湾' }, { 'id': 23, 'name': '格林自由成' }, { 'id': 24, 'name': '格林玫瑰湾' }, { 'id': 25, 'name': '格林阳光城' }, { 'id': 26, 'name': '格林木棉花' }, { 'id': 27, 'name': '优诗美地' }, { 'id': 28, 'name': '河畔新城' }, { 'id': 32, 'name': '格林生活坊二期' }, { 'id': 33, 'name': '朗勤产业园' }, { 'id': 37, 'name': '测试-格林小区' }, { 'id': 40, 'name': '中土大厦' }, { 'id': 41, 'name': '格林集采平台' }, { 'id': 42, 'name': '玫瑰湾A座' }, { 'id': 43, 'name': '广华建筑' }, { 'id': 44, 'name': '2019深圳展会' }, { 'id': 45, 'name': '东方欧博城' }],
                    'loginNumber': 7347,
                    'permission': '*',
                    'ctypes': '57', 
                    'password': '!QAZ@WSX',
                    'munuList': [
                      [
                        { 'id': 1, 
                          'name': '首页', 
                          'children': [
                            { 'id': 1, 'route': 'homepage', 'name': '首页', 'permission': 'homepage' },
                          ] 
                        },
                        { 'id': 2, 
                          'name': '我的消息', 
                          'children': [
                            { 'id': 2, 'route': 'message', 'name': '我的消息', 'permission': 'message' },
                          ] 
                        },
                        { 'id': 3, 
                          'name': '线下赛', 
                          'children': [
                            { 'id': 3, 'route': 'offline', 'name': '线下赛', 'permission': 'offline' },
                          ] 
                        },
                        { 'id': 4, 
                          'name': '线上赛', 
                          'children': [
                            { 'id': 4, 'route': 'online', 'name': '线上赛', 'permission': 'online' },
                          ] 
                        },
                        { 'id': 5, 
                          'name': '赛事管理', 
                          'children': [
                            { 'id': 9, 'route': 'competeProject', 'name': '赛事项目列表', 'permission': 'competeProject' },
                            { 'id': 10, 'route': 'competeCategory', 'name': '赛事类别管理', 'permission': 'competeCategory' },
                            { 'id': 11, 'route': 'competeEvents', 'name': '比赛项管理', 'permission': 'competeEvents' },
                            { 'id': 12, 'route': 'competeGroups', 'name': '组别管理', 'permission': 'competeGroups' },
                            { 'id': 13, 'route': 'competeAgeGroup', 'name': '年龄段管理', 'permission': 'competeAgeGroup' }
                          ] 
                        },
                        { 'id': 6, 
                          'name': '赛会记录', 
                          'children': [
                            { 'id': 6, 'route': 'meetingRecord', 'name': '赛会记录', 'permission': 'meetingRecord' },
                          ] 
                        },
                        { 'id': 7, 
                          'name': '账号管理', 
                          'children': [
                            { 'id': 7, 'route': 'account', 'name': '账号管理', 'permission': 'account' },
                          ] 
                        },
                        { 'id': 8, 
                          'name': '轮播图设置', 
                          'children': [
                            { 'id': 8, 'route': 'rotation', 'name': '轮播图设置', 'permission': 'rotation' },
                          ] 
                        },
                    ], 
                  ],
                  'isClose': 1,
                  'mobile': '13812345678' }                
              } else {
                res1 =
                  { 'id': 100006, 
                    'isDispatch': 1, 
                    'fsToken': 'XxlbSgABhqYF9jUvIUu7N0EfFz2lC3NCBl5upg..', 
                    'style': '#00b1c3,#006d9a',
                    'nickName': '超级管理员',
                    'errMsg': '执行成功',
                    'errCode': 0,
                    'gardenList': [{ 'id': 0, 'name': '全部小区' }, { 'id': 9, 'name': '格林生活坊一期' }, { 'id': 11, 'name': '格林生活坊三期' }, { 'id': 12, 'name': '格林观堂一期' }, { 'id': 13, 'name': '格林观堂二期' }, { 'id': 14, 'name': '格林喜鹊花园' }, { 'id': 15, 'name': '格林SOHO' }, { 'id': 16, 'name': '格林常青藤' }, { 'id': 17, 'name': '格林繁荣里' }, { 'id': 18, 'name': '格林豪森' }, { 'id': 19, 'name': '格林康泉府' }, { 'id': 20, 'name': '格林梦夏' }, { 'id': 21, 'name': '格林mini' }, { 'id': 22, 'name': '格林馨港湾' }, { 'id': 23, 'name': '格林自由成' }, { 'id': 24, 'name': '格林玫瑰湾' }, { 'id': 25, 'name': '格林阳光城' }, { 'id': 26, 'name': '格林木棉花' }, { 'id': 27, 'name': '优诗美地' }, { 'id': 28, 'name': '河畔新城' }, { 'id': 32, 'name': '格林生活坊二期' }, { 'id': 33, 'name': '朗勤产业园' }, { 'id': 37, 'name': '测试-格林小区' }, { 'id': 40, 'name': '中土大厦' }, { 'id': 41, 'name': '格林集采平台' }, { 'id': 42, 'name': '玫瑰湾A座' }, { 'id': 43, 'name': '广华建筑' }, { 'id': 44, 'name': '2019深圳展会' }, { 'id': 45, 'name': '东方欧博城' }],
                    'loginNumber': 7347,
                    'permission': '*',
                    'ctypes': '57', 
                    'password': '!QAZ@WSX',
                    'munuList': [
                      [
                        { 'id': 1, 
                          'name': '首页', 
                          'children': [
                            { 'id': 1, 'route': 'homepage', 'name': '首页', 'permission': 'homepage' },
                          ] 
                        },
                        { 'id': 2, 
                          'name': '我的消息', 
                          'children': [
                            { 'id': 2, 'route': 'message', 'name': '我的消息', 'permission': 'message' },
                          ] 
                        },
                        { 'id': 3, 
                          'name': '线下赛', 
                          'children': [
                            { 'id': 3, 'route': 'offline', 'name': '线下赛', 'permission': 'offline' },
                          ] 
                        },
                        { 'id': 4, 
                          'name': '线上赛', 
                          'children': [
                            { 'id': 4, 'route': 'online', 'name': '线上赛', 'permission': 'online' },
                          ] 
                        },
                        { 'id': 5, 
                          'name': '赛事管理', 
                          'children': [
                            { 'id': 9, 'route': 'competeProject', 'name': '赛事项目列表', 'permission': 'competeProject' },
                            { 'id': 10, 'route': 'competeCategory', 'name': '赛事类别管理', 'permission': 'competeCategory' },
                            { 'id': 11, 'route': 'competeEvents', 'name': '比赛项管理', 'permission': 'competeEvents' },
                            { 'id': 12, 'route': 'competeGroups', 'name': '组别管理', 'permission': 'competeGroups' },
                            { 'id': 13, 'route': 'competeAgeGroup', 'name': '年龄段管理', 'permission': 'competeAgeGroup' }
                          ] 
                        },
                        { 'id': 6, 
                          'name': '赛会记录', 
                          'children': [
                            { 'id': 6, 'route': 'meetingRecord', 'name': '赛会记录', 'permission': 'meetingRecord' },
                          ] 
                        },
                        { 'id': 8, 
                          'name': '轮播图设置', 
                          'children': [
                            { 'id': 8, 'route': 'rotation', 'name': '轮播图设置', 'permission': 'rotation' },
                          ] 
                        },
                    ], 
                  ],
                  'isClose': 1,
                  'mobile': '13812345678' }                
              }
              res1.fsToken = res.fsToken
              res = res1
              if (res && res.errCode === 0) { // 成功后先把信息先存入到localStorage里面
                res.password = Base64.encode(res.password) // 密码base64加密
                // alert(Base64.decode(res.password)) // 密码解密
                window.localStorage.setItem('userId', JSON.stringify(this.ruleForm.name))
                window.localStorage.setItem('userData', JSON.stringify(res))
                window.localStorage.setItem('userpassword', JSON.stringify(res.password))
                window.localStorage.setItem('userGardenList', JSON.stringify(res.gardenList)) // 账号下的小区权限
                window.localStorage.setItem('userMunuList', JSON.stringify(res.munuList)) // 账号下的菜单权限
                window.localStorage.setItem('changeGardens', JSON.stringify(res.isClose)) // 账号下小区切换时菜单更改
                window.localStorage.setItem('userName', JSON.stringify(res.nickName))
              }
              // 记忆赛事项目的pageSize和pageNum
              window.localStorage.setItem('competeItemPageSize', JSON.stringify(10))
              window.localStorage.setItem('competeItemPageNum', JSON.stringify(1))
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 解决
    evil(fn) {
      let Fn = Function // 一个变量指向Function，防止有些前端编译工具报错
        return new Fn('return ' + fn)()
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.loginClass.backgroundImage = 'url(' + require('../../assets/imgs/bg0' + new Date().getDay() + '.jpg') + ')'
    this.listenEnter()
    localStorage.clear()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 这里存放数据
  beforeCreate() {},
  // 生命周期 - 挂载之前
  beforeMount() {},
  // 生命周期 - 更新之前
  beforeUpdate() {},
  // 生命周期 - 更新之后
  updated() {},
  // 生命周期 - 销毁之前
  beforeDestroy() {},
  // 生命周期 - 销毁完成
  destroyed() {},
  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() {}
}
</script>

<style lang='scss'>
.loginClass{
  .el-card {
    border: 0px solid #EBEEF5 !important;
    padding: 0px !important;; 
    border-radius: 0px !important;;
  }
  .background{
      width:100%;  
      height:100%;  /**宽高100%是为了图片铺满屏幕 */
      z-index:-1;
      position: absolute;
  }
}
.login-card {
  // filter:alpha(Opacity=20);-moz-opacity:0.2;opacity: 0.2; 
  background-color:rgba(255, 255, 255, 0.2) !important;
  width: 400px;
  height: 440px;
  z-index:1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  .blue {
    background-color:#095edf;
    height: 8px;
    width: 400px;
    margin-top: 0px;
  }
  // .line1{
  //   border-bottom:2px solid #999999;
  //   height: 24px;
  //   margin-top: 0px;
  //   margin-left: 32px;
  //   width: 72px;
  // }
  .line2{
    border-bottom:2px solid #999999;
    height: 24px;
    margin-left: 32px;
    margin-right: 32px;
  }
  .inputext1 {
    margin-top: 45px;
    // margin-left: 32px;
    width: 334px;
    height: 42px;
    z-index: 999;
    opacity: 1!important; 
  }
  .inputext2 {
    margin-top: 20-20px;
    // margin-left: 32px;
    width: 334px;
    height: 42px;
    z-index: 999;
    opacity: 1!important; 
  }
  .btn1 {
    background-color:#095edf;
    border: 0px solid #DCDFE6;
    margin-top: 60-20px;
    margin-left: 32px;
    margin-bottom: 80px;
    width: 334px;
    height: 42px;
    z-index: 999;
    opacity: 1!important; 
  }
  p{
    color: white;
    margin-top: 48px;
    // margin-left: 32px;
    font-size: 18px;
    text-align: center;
    opacity: 1!important; 
  }
}

</style>